console.log("init Proteus treatments -- 1.04")

if(window.location.pathname == "/practitioner"){
  window.location.href = "/account/register?type=practitioner"
}

/* 
waitUntil(() => {
  return window.ARG_CUSTOMER?.tags.length > 0
}).then(() => {
*/
setTimeout(() => {

  let customer_tags = (window.ARG_CUSTOMER?.tags || []).map(t => t.toLowerCase());
  let is_not_consumer = !customer_tags.some(t => t === 'consumer');
  let is_practitioner = customer_tags.some(t => t === 'practitioner');

  // START support for excess DTC

  if(window.location.href.indexOf("/collections/exclusive-savings") > -1 &&
  window.location.href.indexOf("/products/") == -1){
    
    window.sessionStorage.setItem("exclusive savings DTC", true); // otp by default
    // Read by initialMode() in snippets/subscription-ui.liquid, which forces a one-time purchase
    // when this is set. Was read by ARG-10 before that treatment was retired.
    
    if(is_not_consumer){
      window.location.href = "/"; // redir to HP
    }
  }

  if(is_not_consumer){
    observeSelector('[href*="/collections/exclusive-savings"]', savings_link => {
      savings_link.remove();
    });
  }  

  const waitForInShadow = (host, selector, timeout = 5000) => new Promise((resolve, reject) => {
    const start = Date.now();
    const iv = setInterval(() => {
      const el = host.shadowRoot?.querySelector(selector);   // ?. → safe if root still null
      if (el) { clearInterval(iv); resolve(el); }
      else if (Date.now() - start > timeout) { clearInterval(iv); reject(new Error(`timeout: ${selector}`)); }
    }, 100);
  });

  observeSelector(".quick-buy-drawer__info recharge-subscription-widget", quickbuy_options => {
    if(window.sessionStorage.getItem("exclusive savings DTC")){
      waitForInShadow(quickbuy_options, '.rc-selection__onetime label')
      .then(label => label.click())
      .catch(err => console.warn('OTP toggle skipped:', err.message));
    }
  });

  // END support for excess DTC

  // START [ARG-15]

  if(window.sessionStorage.getItem("[ARG-15] active") && 
  !window.customer_purchased_glandular_adapt){

    setTimeout(() => {

      if(is_practitioner){

        proteus.add_cartAttribute("_proteus_discount_1", "gwp_tier_1");
        
        observeSelector('free-shipping-bar', fs => {
          let line_items = document.querySelectorAll('line-item');
          if(line_items.length == 1 || window.sessionStorage.getItem("[ARG-15] first item in cart is glandular adapt")){
            if(document.querySelectorAll('line-item a[href*="/products/adrenal-glandular-adapt?variant=51594194321709"]').length > 0){
              window.sessionStorage.setItem("[ARG-15] first item in cart is glandular adapt", true);
              return
            } else {
              window.sessionStorage.setItem("[ARG-15] first item in cart is glandular adapt", false);
            }
          }

          // console.log("doing the thing is_practitioner", is_practitioner);

          fs.insertAdjacentHTML("beforebegin", `
          <div class="proteus-progress proteus-progress--linear"
            data-proteus-progress
            data-config='{
            "layout": "linear",
            "fillMode": "linear",
            "thresholdType": "cart_original_total",
            "tiers": [{
                  "threshold": 300,
                  "messageUnmet": "Spend [remaining] more for a complimentary trial bottle of AGA §",
                  "messageMet": "✓ Enjoy an Adrenal Glandular Adapt"
          , "gwp": {
            "title": "Adrenal Glandular Adapt",
            "variantIds": [51594194321709],
            "quantity": 1,
            "lineItemProperty": {"_proteus_discount_1": "gwp_tier_1"},
            "description": "Adaptogenic and glandular support for adrenal resilience and cortisol regulation §",
            "imageUrl": "https://allergyresearchgroup.com/cdn/shop/files/71810_Thyroid.png?v=1731374181&width=1200",
            "value": "$51.99",
            "price": "Free"
          }
          }],
            "markerStyle": "notch",
            "celebrate": true,
            "hideWhenEmpty": true,
            "presentmentCurrency": true,
            "activationAttr": "",
            "collectionProductIds": [],
            "unitSingular": "item",
            "unitPlural": "items",
            "gwpButtonLabel": "Claim Complimentary Product"
          }'
          style="--pp-fill: #1a1a1a; --pp-track: #e5e5e5; --pp-text: #1a1a1a; --pp-height: 8px; --pp-radius: 4px;"
          ></div>
          `);
          fs.remove();

        });

        // if claimed, inject legal text
        /*
        observeSelector('.badge[data-content="§ Free with orders $300+"]', discount_applied => {
          discount_applied.closest('line-item').insertAdjacentHTML("afterend", 
            `<div id="arg15-legal" style="padding: 1rem; font-size: 11px; opacity: 1;">§ Offer is limited to one bottle of Adrenal Glandular Adapt per practitioner, while supplies last. Each bottle contains 90 vegetarian capsules and has a wholesale price of $26.00. Product has an expiration date of October 31, 2027.</div>`
          );
        })
        */

          
        waitForElement('cart-drawer').then(cart_drawer => {
            if(cart_drawer.shadowRoot.querySelectorAll('#arg15-legal').length == 0){
              cart_drawer.shadowRoot.querySelector('footer').insertAdjacentHTML("beforebegin", 
                `<div id="arg15-legal" style="padding: 1rem; font-size: 12px; opacity: 1;">§ Offer is limited to one bottle of Adrenal Glandular Adapt per practitioner, while supplies last. Each bottle contains 90 vegetarian capsules and has a wholesale price of $26.00. Product has an expiration date of October 31, 2027.</div>`
              );
            }
        }).catch();
          
          
        

      }

    }, 1500)

  }
  // END [ARG-15]

}, 500);

//
// START shipping delay for inventory check
//

function in_time_window() {
  const now = new Date();

  // start/end in PDT explicitly (-7:00)
  const start = new Date("2026-09-01T06:00:00-05:00"); // SEP 01, 6:00 AM PDT
  const end   = new Date("2026-09-07T23:59:59-05:00"); // SEP 07, 11:59:59 PM PDT

  return now >= start && now <= end;
}

if (in_time_window() || window.location.href.indexOf("?shipping") > -1) {
  
  setTimeout(() => {
    proteus.add_cartAttribute("proteus_checkout_option", "shipping note active");
  }, 2500)
  
  observeSelector('cart-drawer form.buy-buttons', checkout => {
    checkout.insertAdjacentHTML("afterend", `
      <style>
      .js-shipping-message{
        text-align: center;
        position: relative;
        font-size: .85rem;
        border-radius: 10px;
        margin: auto;
        max-width: 300px;
      }
      .js-shipping-message:before{
        content: "i";
        position: absolute;
        left: -1.5rem;
        top: 0;
        font-size: 12px;
        line-height: 0;
        border: 1px solid;
        border-radius: 100%;
        width: 1.25rem;
        height: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      </style>
      <div style="margin: 0 2rem 0 3rem;">
        <div class="js-shipping-message">
          Please be aware, orders placed Friday, September 4 through Monday, September 7 will ship out Tuesday, September 8.
        </div>  
      </div>
    `);
  })
}

//
// END shipping delay for inventory check
//


// [ARG-14] — Frequency dropdown labels with servings/day info
window.activateARG14 = function () {
  /* Declared here rather than assigned to a global. It used to be a top-level helper shared
     with ARG-10; that treatment is gone, and this is the only remaining caller. */
  const getUnitsPerContainer = function(variantId) {
    const variantLevel = parseFloat(window.ARG_VARIANT_METAFIELDS?.[String(variantId)]?.unitsPerContainer);
    if (!isNaN(variantLevel) && variantLevel > 0) return variantLevel;
    const singleSize = parseFloat(window.ARG_PRODUCT_METAFIELDS?.unitsPerContainer);
    return isNaN(singleSize) || singleSize <= 0 ? null : singleSize;
  };

  function updateFreqLabels() {
    const freqSelect = document.querySelector('#arg-frequency-select');
    if (!freqSelect) return;

    const variantId = document.querySelector('.arg-size-card.is-selected')?.dataset.variantId
      || document.querySelector('.arg-size-card')?.dataset.variantId;

    const servingSize = parseFloat(window.ARG_PRODUCT_METAFIELDS?.servingSize);
    const unitsPerContainer = getUnitsPerContainer(variantId);

    if (!servingSize || !unitsPerContainer) return;

    const servingsInBottle = unitsPerContainer / servingSize;

    function servingsPerDayLabel(months) {
      const spd = servingsInBottle / (months * 30);
      if (Number.isInteger(spd) && spd > 1) return `${spd} servings / day`;
      if (spd >= 1.8) return `~${Math.round(spd)} servings / day`;
      if (Math.abs(spd - 1) < 0.01) return `1 serving / day`;
      if (spd >= 0.8) return `~1 serving / day`;
      if (Math.abs(spd - 0.5) < 0.01) return `1 serving / every other day`;
      if (spd >= 0.45) return `~1 serving / every other day`;
      const days = 1 / spd;
      return Number.isInteger(days) ? `1 serving / every ${days} days` : `1 serving / every ~${Math.round(days)} days`;
    }

    Array.from(freqSelect.options).forEach(option => {
      const monthMatch = option.textContent.match(/(\d+)\s*month/i);
      if (!monthMatch) return;
      const months = parseInt(monthMatch[1], 10);
      const baseLabel = `Every ${months} Month${months > 1 ? 's' : ''}`;
      option.textContent = `${baseLabel} (${servingsPerDayLabel(months)})`;
    });

    // Auto-select the option closest to 1 serving / day
    let bestOption = null;
    let bestDiff = Infinity;

    Array.from(freqSelect.options).forEach(option => {
      const monthMatch = option.textContent.match(/(\d+)\s*month/i);
      if (!monthMatch) return;
      const months = parseInt(monthMatch[1], 10);
      const spd = servingsInBottle / (months * 30);
      const diff = Math.abs(spd - 1);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestOption = option;
      }
    });

    if (bestOption) {
      freqSelect.value = bestOption.value;
      freqSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  waitUntil(() => document.querySelector('#arg-frequency-select')).then(() => {
    updateFreqLabels();

    const freqSelect = document.querySelector('#arg-frequency-select');
    
    let _arg14Updating = false;
    new MutationObserver(() => {
      if (_arg14Updating) return;
      _arg14Updating = true;
      updateFreqLabels();
      _arg14Updating = false;
    }).observe(freqSelect, { childList: true });

  }).catch();

  // Re-run when selected size card changes
  observeSelector('.arg-size-card.is-selected', () => {
    updateFreqLabels();
  });
};
/// end [ARG-14]

// [ARG-16] — Default to the largest size card on load
window.activateARG16 = function () {
  /* Was a top-level helper shared with ARG-10; moved in as the only remaining caller. */
  const getVariantIdFromUrl = () =>
    new URLSearchParams(window.location.search).get("variant") || "";

  waitUntil(() => document.querySelector('.arg-size-card')).then(() => {
    if (getVariantIdFromUrl()) return;
    const cards = document.querySelectorAll('.arg-size-card');
    if (cards.length === 0) return;
    cards[cards.length - 1].click();
  }).catch();
};
/// end [ARG-16]

// [ARG-17 v2] — Move the "Ask me anything" chat into the search drawer
window.activateARG17 = function () {
  'use strict';
  if (window.__ARG17) return;
  window.__ARG17 = true;

  /* ---------- config ---------- */
  var DRAWER_ID  = 'header-sidebar-menu';   // Impact mobile nav <navigation-drawer>
  var DESKTOP_MQ = '(min-width: 1150px)';   // theme's lg breakpoint
  var DT_INSET   = 20;  // desktop: row inset from right edge
  var DT_BASE    = 20;  // desktop: row offset from bottom
  var G_ICON_PAD = 8;   // compensation for transparent padding inside Google's wrapper
  var M_SIDE     = 16;  // mobile row: inset from menu panel's right edge
  var M_BOTTOM   = 84;  // mobile row: offset up from menu panel's bottom edge
  var GAP        = 14;  // visual gap between widgets

  var DT_ACSB_GAP_RIGHT = 8;
  var DT_ACSB_RIGHT  = 103;
  var DT_ACSB_BOTTOM = 40;
  var DT_SHIELD_RIGHT  = 162;
  var DT_SHIELD_BOTTOM = 35;
  var AMA_DT_BOTTOM = 100;
  var mqDesktop = window.matchMedia(DESKTOP_MQ);
  var cache = {};
  var scheduled = false;
  var writeCount = 0;
  var hotTicks = 0;
  var pauseUntil = 0;
  var lastGw = 84, lastGh = 84;
  var ducked = false;


  /* ---------- scheduler ---------- */
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var fired = false;
    var raf = requestAnimationFrame(go);
    var tmo = setTimeout(go, 80);
    function go() {
      if (fired) return;
      fired = true;
      cancelAnimationFrame(raf);
      clearTimeout(tmo);
      scheduled = false;
      run();
    }
  }

  /* ---------- element resolution ---------- */
  function watchStyle(el) {
    if (el.__ptObs) return;
    el.__ptObs = true;
    new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['style'] });
  }
  function watchClassStyle(el) {
    if (el.__ptObs) return;
    el.__ptObs = true;
    new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  function live(key, find) {
    var el = cache[key];
    if (el && el.isConnected) return el;
    el = find() || null;
    cache[key] = el;
    if (el && key === 'g') watchStyle(el);
    if (el && key === 'a') watchClassStyle(el);
    if (el && key === 's') {
      var root = el.getRootNode();
      if (root && !root.__ptObs) {
        root.__ptObs = true;
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      }
    }
    return el;
  }
  function google() { return live('g', function () { return document.getElementById('google-merchantwidget-iframe-wrapper'); }); }
  function shield() {
    return live('s', function () {
      var h = document.querySelector('csm-cookie-consent');
      if (!h || !h.shadowRoot) return null;
      var t = h.shadowRoot.querySelector('[class*="reopen"]');
      while (t && getComputedStyle(t).position !== 'fixed') t = t.parentElement;
      return t;
    });
  }
  function acsb() {
    return live('a', function () {
      var hosts = document.querySelectorAll('access-widget-ui');
      for (var i = 0; i < hosts.length; i++) {
        if (!hosts[i].shadowRoot) continue;
        var b = hosts[i].shadowRoot.querySelector('button[class*="trigger-button"]');
        if (b) { patchAcsbShadow(hosts[i]); return b; }
      }
      return null;
    });
  }

  function patchAcsbShadow(host) {
    if (!host.shadowRoot || host.shadowRoot.getElementById('arg17-acsb-fix')) return;
    var st = document.createElement('style');
    st.id = 'arg17-acsb-fix';
    st.textContent = [
      '.trigger-button,[class*="trigger-button"]{transition:transform .15s!important;}',
      '.icon svg{visibility:inherit!important;}'
    ].join('');
    host.shadowRoot.appendChild(st);
  }

  function drawer() { return document.getElementById(DRAWER_ID); }
  function menuOpen() { var d = drawer(); return !!(d && d.hasAttribute('open') && d.offsetWidth > 0); }

  var WIDGET_HOSTS = 'access-widget-ui, csm-cookie-consent, [id*="merchantwidget"]';

  function isWidgetNode(node) {
    return !!(node && node.closest && node.closest(WIDGET_HOSTS));
  }
  function eventHitsWidget(event) {
    var deep = (event.composedPath && event.composedPath()[0]) || null;
    return isWidgetNode(deep) || isWidgetNode(event.target);
  }

  function protectDrawer() {
    var d = drawer();
    if (!d || d.__arg17Protected) return;
    d.__arg17Protected = true;

    var native = Node.prototype.contains;
    d.contains = function (node) {
      if (native.call(this, node)) return true;
      return isWidgetNode(node);
    };

    var origTouch = d._allowOutsideClickTouch;
    var origMouse = d._allowOutsideClickMouse;
    d._allowOutsideClickTouch = function (event) {
      if (eventHitsWidget(event)) return true;
      return origTouch.call(this, event);
    };
    d._allowOutsideClickMouse = function (event) {
      if (eventHitsWidget(event)) return true;
      return origMouse.call(this, event);
    };
  }

  /* ---------- style helpers ---------- */
  function setImp(el, prop, val) {
    if (el.style.getPropertyValue(prop) !== val) { writeCount++; el.style.setProperty(prop, val, 'important'); }
  }
  function clearProp(el, prop) {
    if (el.style.getPropertyValue(prop) !== '') { writeCount++; el.style.removeProperty(prop); }
  }
  function show(el) { clearProp(el, 'visibility'); clearProp(el, 'pointer-events'); }
  function hide(el) { setImp(el, 'visibility', 'hidden'); setImp(el, 'pointer-events', 'none'); }

  var CSM_UNPOP_MAX = 20;
  var csmUnpopCount = 0;
  var csmUnpopped = false;

  function shieldStacking(host, belowZ) {
    if (csmPanelVisible()) {
      clearProp(host, 'z-index');
      if (typeof host.showPopover === 'function' && !host.matches(':popover-open')) {
        try { host.showPopover(); } catch (e) {}
      }
      csmUnpopped = false;
      return;
    }

    setImp(host, 'z-index', belowZ);
    if (csmUnpopCount >= CSM_UNPOP_MAX) return;
    if (typeof host.hidePopover !== 'function') return;
    try {
      if (host.matches(':popover-open')) {
        host.hidePopover();
        csmUnpopped = true;
        csmUnpopCount++;
      }
    } catch (e) {
      csmUnpopCount = CSM_UNPOP_MAX;
    }
  }

  function shieldIcon(s) {
    if (!s) return null;
    var i = s.querySelector('[class*="reopen"]');
    return (i && i !== s) ? i : null;
  }

  /* ---------- accessiBe interface open? ---------- */
  function acsbInterfaceOpen() {
    var a = cache.a;
    if (a && a.isConnected && /trigger-button--visible/.test(String(a.className))) return false;
    var el = cache.ai;
    if (!(el && el.isConnected)) {
      el = null;
      var hosts = document.querySelectorAll('access-widget-ui');
      for (var i = 0; i < hosts.length && !el; i++) {
        var sr = hosts[i].shadowRoot;
        if (!sr) continue;
        var all = sr.querySelectorAll('*');
        for (var j = 0; j < all.length; j++) {
          var r = all[j].getBoundingClientRect();
          if (r.width > 250 && r.height > 400) { el = all[j]; break; }
        }
      }
      cache.ai = el;
      if (el) watchClassStyle(el);
    }
    if (!el) return false;
    var cs = getComputedStyle(el);
    var rr = el.getBoundingClientRect();
    return cs.visibility !== 'hidden' && cs.display !== 'none' && rr.width > 250 && rr.height > 400;
  }

  /* ---------- Consentmo settings panel ---------- */
  function csmScan() {
    var h = document.querySelector('csm-cookie-consent');
    if (!h || !h.shadowRoot) return null;
    var best = null;
    h.shadowRoot.querySelectorAll('div').forEach(function (el) {
      var cs = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      var vis = cs.visibility !== 'hidden' && cs.display !== 'none' && r.width > 0;
      var isBig = r.width > 200 && r.height > 150;
      if (el.__ptDlg && (!vis || !isBig)) { el.style.removeProperty('left'); el.__ptDlg = false; }
      if (vis && isBig && r.width < window.innerWidth * 0.9) {
        if (!best || r.width * r.height > best.r.width * best.r.height) best = { el: el, r: r };
      }
    });
    return best;
  }
  
  function csmPanelVisible() {
    var h = document.querySelector('csm-cookie-consent');
    if (!h || !h.shadowRoot) return false;
    var found = false;
    h.shadowRoot.querySelectorAll('div').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none') return;
      var r = el.getBoundingClientRect();
      var panel = r.width > 200 && r.height > 150;
      var bar   = r.width > window.innerWidth * 0.6 && r.height > 60;
      if (panel || bar) found = true;
    });
    return found;
  }
  function steerCsmPanel(best) {
    if (!best) return;
    var vw = window.innerWidth;
    var want = Math.max(4, Math.round(vw - best.r.width - 20));
    var delta = Math.round(best.r.left - want);
    if (Math.abs(delta) > 2) {
      var base = parseFloat(best.el.style.getPropertyValue('left'));
      if (isNaN(base)) base = parseFloat(getComputedStyle(best.el).left);
      if (isNaN(base)) base = 0;
      setImp(best.el, 'left', Math.round(base - delta) + 'px');
      best.el.__ptDlg = true;
    }
  }

  /* ---------- the one state function ---------- */
  function sync() {
    var g = google(), s = shield(), a = acsb();
    var desktop = mqDesktop.matches;

    protectDrawer();

    if (!desktop && !menuOpen()) {
      ducked = false;
      var panelUp = csmPanelVisible();
      if (g) setImp(g, 'display', 'none');
      if (s) {
        var icon = shieldIcon(s);
        if (icon) {
          setImp(icon, 'visibility', 'hidden');
          setImp(icon, 'pointer-events', 'none');
          clearProp(s, 'visibility');
          if (panelUp) clearProp(s, 'pointer-events');
          else setImp(s, 'pointer-events', 'none');
        } else if (panelUp) {
          show(s);
        } else {
          hide(s);
        }
      }
      if (a) hide(a);
      steerCsmPanel(csmScan());
      return;
    }

    ducked = acsbInterfaceOpen();
    if (ducked) {
      if (g) setImp(g, 'display', 'none');
      if (s) {
        var ic3 = shieldIcon(s);
        if (ic3) { setImp(ic3, 'visibility', 'hidden'); setImp(ic3, 'pointer-events', 'none'); }
        else hide(s);
      }
      steerCsmPanel(csmScan());
      return;
    }

    var cRight, inset, base;
    if (desktop) {
      cRight = window.innerWidth; inset = DT_INSET; base = DT_BASE;
    } else {
      var d = drawer();
      var pn = d.querySelector('.panel-list__wrapper') || d;
      var r = pn.getBoundingClientRect();
      cRight = r.right; inset = M_SIDE;
      base = Math.round(Math.max(0, window.innerHeight - r.bottom)) + M_BOTTOM;
    }

    if (s) {
      var icon2 = shieldIcon(s);
      if (icon2) { clearProp(icon2, 'visibility'); clearProp(icon2, 'pointer-events'); }
      show(s);
    }
    if (a) show(a);
    if (g) setImp(g, 'display', 'block');

    var gw = g ? (g.offsetWidth || 84) : 84, gh = g ? (g.offsetHeight || 84) : 84;
    var sw = s ? (s.offsetWidth || 55) : 55, sh = s ? (s.offsetHeight || 55) : 55;
    var aw = a ? (a.offsetWidth || 45) : 45, ah = a ? (a.offsetHeight || 45) : 45;
    var expanded = gh > 150;
    if (!expanded && g) { lastGw = gw; lastGh = gh; }
    var ghNom = expanded ? lastGh : gh;
    var gwNom = expanded ? lastGw : gw;
    var gVis = Math.min(gwNom, ghNom);
    var rowH = Math.max(sh, ah, gVis, 1);
    var gRightWanted = Math.round(window.innerWidth - cRight + inset);
    var gRight = gRightWanted;
    if (window.innerWidth - gRight - gw < 8) gRight = Math.max(4, window.innerWidth - gw - 8);
    if (g) {
      var gBottom;
      if (!expanded) {
        gBottom = Math.round(base + (rowH - gh) / 2);
      } else {
        var anchor = Math.round(base + (rowH - ghNom) / 2);
        gBottom = Math.min(anchor, window.innerHeight - gh - 8);
      }
      if (gBottom < 4) gBottom = 4;
      setImp(g, 'top', 'auto');
      setImp(g, 'left', 'auto');
      setImp(g, 'right', gRight + 'px');
      setImp(g, 'bottom', gBottom + 'px');
    }

    var gNomLeft = (window.innerWidth - gRight) - gVis;
    var aLeft = gNomLeft + G_ICON_PAD - GAP - aw - (desktop ? DT_ACSB_GAP_RIGHT : 0);
    var sLeft = aLeft - GAP - sw;
    var gZ = g ? (parseInt(getComputedStyle(g).zIndex, 10) || 2147483647) : 2147483647;
    var stackBelowG = String(Math.max(0, gZ - 1));

    if (a) {
      if (desktop) {
        var cw = document.documentElement.clientWidth;
        setImp(a, 'top', 'auto');
        setImp(a, 'right', 'auto');
        setImp(a, 'left', Math.round(cw - DT_ACSB_RIGHT - aw) + 'px');
        setImp(a, 'bottom', DT_ACSB_BOTTOM + 'px');
      } else {
        setImp(a, 'top', 'auto');
        setImp(a, 'right', 'auto');
        setImp(a, 'left', Math.round(aLeft) + 'px');
        setImp(a, 'bottom', Math.round(base + (rowH - ah) / 2) + 'px');
      }
      setImp(a, 'z-index', stackBelowG);
    }
    if (s) {
      if (desktop) {
        var cwS = document.documentElement.clientWidth;
        setImp(s, 'top', 'auto');
        setImp(s, 'right', 'auto');
        setImp(s, 'left', Math.round(cwS - DT_SHIELD_RIGHT - sw) + 'px');
        setImp(s, 'bottom', DT_SHIELD_BOTTOM + 'px');
      } else {
        setImp(s, 'top', 'auto');
        setImp(s, 'right', 'auto');
        setImp(s, 'left', Math.round(sLeft) + 'px');
        setImp(s, 'bottom', Math.round(base + (rowH - sh) / 2) + 'px');
      }
      setImp(s, 'z-index', stackBelowG);
      s.__arg17Placed = true;
    }

    var csmHost = document.querySelector('csm-cookie-consent');
    if (csmHost) shieldStacking(csmHost, stackBelowG);

    steerCsmPanel(csmScan());
  }

  function shieldNeedsPlacement() {
    var el = shield();
    return !!(el && !el.__arg17Placed);
  }

  function run() {
    if (Date.now() < pauseUntil && !shieldNeedsPlacement()) return;
    var w0 = writeCount;
    try { sync(); } catch (e) { /* never take the page down */ }
    hotTicks = (writeCount > w0) ? hotTicks + 1 : 0;
    if (hotTicks > 60) {
      hotTicks = 0;
      pauseUntil = Date.now() + 3000;
      return;
    }
    var d = drawer();
    if ((!mqDesktop.matches && d && d.hasAttribute('open')) || ducked) schedule();
  }

  function liftAma() {
    if (document.getElementById('arg17-ama-lift')) return;
    var st = document.createElement('style');
    st.id = 'arg17-ama-lift';
    st.textContent = '@media ' + DESKTOP_MQ + '{body #hubspot-messages-iframe-container{bottom:' +
                     AMA_DT_BOTTOM + 'px!important;}}';
    document.head.appendChild(st);
  }

  function init() {
    liftAma();

    var d = drawer();
    if (d) {
      new MutationObserver(schedule).observe(d, { attributes: true, attributeFilter: ['open'] });
    }
    mqDesktop.addEventListener ? mqDesktop.addEventListener('change', schedule) : mqDesktop.addListener(schedule);
    window.addEventListener('resize', schedule);
    document.addEventListener('visibilitychange', schedule);
    setInterval(schedule, 1200);
    var mo = new MutationObserver(function () {
      var ok = cache.g && cache.g.isConnected && cache.s && cache.s.isConnected && cache.a && cache.a.isConnected;
      if (!ok) schedule();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
};
/// end [ARG-17 v2]

observeSelector('[src*="rebuy"], [class*="rebuy"], [id*="rebuy"]', rebuy_element => {
  rebuy_element.remove();
});